export const comparisonTitles = [
  {
    title: 'Features',
    list: [
      'Servers',
      '2FA Protection',
      'IP Whitelist',
      'Low Latency',
      'Priority Support',
      'Dedicated Shard',
      'Custom Branding',
      'Dedicated VPS',
      'Early-access tools',
    ],
  },
  {
    title: 'Anti-Webook',
    list: [
      'Custom Punishment',
      'Allowed Channels',
      'Q/F Control',
      'Whitelist',
      'Notifications',
      'Domain Filter',
    ],
  },
  {
    title: 'Anti-Spam',
    list: ['Custom Punishment', 'Custom Filters', 'Flag Control', 'Notifications', 'Domain Filter'],
  },
  {
    title: 'Verification',
    list: [
      'Numerical Captcha',
      'Classical Captcha',
      'Rule Message',
      'Embed Message',
      'Cross-Server Detection',
      'Image Captcha',
    ],
  },
  {
    title: 'Anti-Nuke',
    list: [
      'Custom Punishment',
      'Custom Filters',
      'Flag Control',
      'Advanced Flags',
      'Notifications',
      'Domain Filter',
    ],
  },
  {
    title: 'Fake Detection',
    list: [
      'Custom Punishment',
      'Whitelist',
      'Flag Control',
      'AI-text detection',
      'Name Similarity',
      'Notifications',
    ],
  },
  {
    title: 'Anti-Raid',
    list: [
      'Custom Punishment',
      'Q/F Control',
      'Cross-Server Detection',
      'Account Age',
      'Notifications',
    ],
  },
];

export const comparisonArr = [
  {
    id: '1',
    label: 'free',
    price: 0,
    condition: '',
    features: {
      Features: {
        Servers: 'infinity',
        '2FA Protection': 'check',
        'IP Whitelist': 'check',
      },
      'Anti-Webook': {
        'Custom Punishment': 'check',
        'Allowed Channels': 'check',
        'Q/F Control': 'check',
        Whitelist: 'check',
      },
      'Anti-Spam': {
        'Custom Punishment': 'check',
        'Custom Filters': 'check',
        'Flag Control': 'check',
      },
      Verification: {
        'Numerical Captcha': 'check',
        'Classical Captcha': 'check',
        'Rule Message': 'check',
        'Embed Message': 'check',
      },
      'Anti-Nuke': {
        'Custom Punishment': 'check',
        'Custom Filters': 'check',
        'Flag Control': 'check',
      },
      'Fake Detection': {
        'Custom Punishment': 'check',
        Whitelist: 'check',
        'Flag Control': 'check',
      },
      'Anti-Raid': {
        'Custom Punishment': 'check',
        'Q/F Control': 'check',
        'Cross-Server Detection': 'check',
      },
    },
  },
  {
    id: '2',
    label: 'pro',
    mark: 'monthly',
    price: 0,
    condition: 'per month',
    features: {
      Features: {
        Servers: 'infinity',
        '2FA Protection': 'check',
        'IP Whitelist': 'check',
        'Low Latency': 'check',
        'Priority Support': 'check',
        'Dedicated Shard': 'check',
      },
      'Anti-Webook': {
        'Custom Punishment': 'check',
        'Allowed Channels': 'check',
        'Q/F Control': 'check',
        Whitelist: 'check',
        Notifications: 'check',
        'Domain Filter': 'check',
      },
      'Anti-Spam': {
        'Custom Punishment': 'check',
        'Custom Filters': 'check',
        'Flag Control': 'check',
        Notifications: 'check',
        'Domain Filter': 'check',
      },
      Verification: {
        'Numerical Captcha': 'check',
        'Classical Captcha': 'check',
        'Rule Message': 'check',
        'Embed Message': 'check',
        'Cross-Server Detection': 'check',
        'Image Captcha': 'check',
      },
      'Anti-Nuke': {
        'Custom Punishment': 'check',
        'Custom Filters': 'check',
        'Flag Control': 'check',
        'Advanced Flags': 'check',
        Notifications: 'check',
        'Domain Filter': 'check',
      },
      'Fake Detection': {
        'Custom Punishment': 'check',
        Whitelist: 'check',
        'Flag Control': 'check',
        'AI-text detection': 'check',
        'Name Similarity': 'check',
        Notifications: 'check',
      },
      'Anti-Raid': {
        'Custom Punishment': 'check',
        'Q/F Control': 'check',
        'Cross-Server Detection': 'check',
        'Account Age': 'check',
        Notifications: 'check',
      },
    },
  },
  {
    id: '3',
    label: 'enterprise',
    price: 300,
    mark: 'annually',
    condition: 'per year',
    features: {
      Features: {
        Servers: 'infinity',
        '2FA Protection': 'check',
        'IP Whitelist': 'check',
        'Low Latency': 'check',
        'Priority Support': 'check',
        'Dedicated Shard': 'check',
        'Custom Branding': 'check',
        'Dedicated VPS': 'check',
        'Early-access tools': 'check',
      },
      'Anti-Webook': {
        'Custom Punishment': 'check',
        'Allowed Channels': 'check',
        'Q/F Control': 'check',
        Whitelist: 'check',
        Notifications: 'check',
        'Domain Filter': 'check',
      },
      'Anti-Spam': {
        'Custom Punishment': 'check',
        'Custom Filters': 'check',
        'Flag Control': 'check',
        Notifications: 'check',
        'Domain Filter': 'check',
      },
      Verification: {
        'Numerical Captcha': 'check',
        'Classical Captcha': 'check',
        'Rule Message': 'check',
        'Embed Message': 'check',
        'Cross-Server Detection': 'check',
        'Image Captcha': 'check',
      },
      'Anti-Nuke': {
        'Custom Punishment': 'check',
        'Custom Filters': 'check',
        'Flag Control': 'check',
        'Advanced Flags': 'check',
        Notifications: 'check',
        'Domain Filter': 'check',
      },
      'Fake Detection': {
        'Custom Punishment': 'check',
        Whitelist: 'check',
        'Flag Control': 'check',
        'AI-text detection': 'check',
        'Name Similarity': 'check',
        Notifications: 'check',
      },
      'Anti-Raid': {
        'Custom Punishment': 'check',
        'Q/F Control': 'check',
        'Cross-Server Detection': 'check',
        'Account Age': 'check',
        Notifications: 'check',
      },
    },
  },
];

export const comparisonMobArr = {
  header: [
    {
      id: '1',
      label: 'free',

      price: 0,
      condition: '',
    },
    {id: '2', label: 'pro', mark: 'monthly', price: 0, condition: 'per month'},
    {id: '3', label: 'enterprise', mark: 'annually', price: 300, condition: 'per year'},
  ],
  footer: [
    {
      title: 'Features',
      features: [
        {
          name: 'Servers',
          list: ['infinity', 'infinity', 'infinity'],
        },
        {
          name: '2FA Protection',
          list: ['check', 'check', 'check'],
        },
        {
          name: 'IP Whitelist',
          list: ['check', 'check', 'check'],
        },
        {
          name: 'Low Latency',
          list: ['-', 'check', 'check'],
        },
        {
          name: 'Priority Support',
          list: ['-', 'check', 'check'],
        },
        {
          name: 'Dedicated Shard',
          list: ['-', 'check', 'check'],
        },
        {
          name: 'Custom Branding',
          list: ['-', '-', 'check'],
        },
        {
          name: 'Dedicated VPS',
          list: ['-', '-', 'check'],
        },
        {
          name: 'Early-access tools',
          list: ['-', '-', 'check'],
        },
      ],
    },
    {
      title: 'Anti-Webook',
      features: [
        {
          name: 'Custom Punishment',
          list: ['check', 'check', 'check'],
        },
        {
          name: 'Allowed Channels',
          list: ['check', 'check', 'check'],
        },
        {
          name: 'Q/F Control',
          list: ['check', 'check', 'check'],
        },
        {
          name: 'Whitelist',
          list: ['check', 'check', 'check'],
        },
        {
          name: 'Notifications',
          list: ['-', 'check', 'check'],
        },
        {
          name: 'Domain Filter',
          list: ['-', 'check', 'check'],
        },
      ],
    },
    {
      title: 'Anti-Spam',
      features: [
        {
          name: 'Custom Punishment',
          list: ['check', 'check', 'check'],
        },
        {
          name: 'Custom Filters',
          list: ['check', 'check', 'check'],
        },
        {
          name: 'Flag Control',
          list: ['check', 'check', 'check'],
        },
        {
          name: 'Notifications',
          list: ['-', 'check', 'check'],
        },
        {
          name: 'Domain Filter',
          list: ['-', 'check', 'check'],
        },
      ],
    },
    {
      title: 'Verification',
      features: [
        {
          name: 'Numerical Captcha',
          list: ['check', 'check', 'check'],
        },
        {
          name: 'Classical Captcha',
          list: ['check', 'check', 'check'],
        },
        {
          name: 'Rule Message',
          list: ['check', 'check', 'check'],
        },
        {
          name: 'Embed Message',
          list: ['check', 'check', 'check'],
        },
        {
          name: 'Cross-Server Detection',
          list: ['-', 'check', 'check'],
        },
        {
          name: 'Image Captcha',
          list: ['-', 'check', 'check'],
        },
      ],
    },
    {
      title: 'Anti-Nuke',
      features: [
        {
          name: 'Custom Punishment',
          list: ['check', 'check', 'check'],
        },
        {
          name: 'Custom Filters',
          list: ['check', 'check', 'check'],
        },
        {
          name: 'Flag Control',
          list: ['check', 'check', 'check'],
        },
        {
          name: 'Advanced Flags',
          list: ['-', 'check', 'check'],
        },
        {
          name: 'Notifications',
          list: ['-', 'check', 'check'],
        },
        {
          name: 'Domain Filter',
          list: ['-', 'check', 'check'],
        },
      ],
    },
    {
      title: 'Fake Detection',
      features: [
        {
          name: 'Custom Punishment',
          list: ['check', 'check', 'check'],
        },
        {
          name: 'Whitelist',
          list: ['check', 'check', 'check'],
        },
        {
          name: 'Flag Control',
          list: ['check', 'check', 'check'],
        },
        {
          name: 'AI-text detection',
          list: ['-', 'check', 'check'],
        },
        {
          name: 'Name Similarity',
          list: ['-', 'check', 'check'],
        },
        {
          name: 'Notifications',
          list: ['-', 'check', 'check'],
        },
      ],
    },
    {
      title: 'Anti-Raid',
      features: [
        {
          name: 'Custom Punishment',
          list: ['check', 'check', 'check'],
        },
        {
          name: 'Q/F Control',
          list: ['check', 'check', 'check'],
        },
        {
          name: 'Cross-Server Detection',
          list: ['check', 'check', 'check'],
        },
        {
          name: 'Account Age',
          list: ['-', 'check', 'check'],
        },
        {
          name: 'Notifications',
          list: ['-', 'check', 'check'],
        },
      ],
    },
  ],
};
